<div class="container">
  <div class="card mx-lg-auto">
    <div class="card-body text-center py-3">
      <div class="card-heading d-flex align-items-center">
        <span class="icon material-icons text-success" aria-hidden="true">add_card</span>
        <span class="success-title text-success fw-bold text-uppercase">{{ 'add.payment.card' | translate }}</span>
      </div>
      <div class="sub-heading-modal">
        <div class="text-center">{{ 'ecash.success.page.card.added' | translate }}</div>
      </div>
      <div class="btn-container mt-2 d-block">
        <button [routerLink]="['/payment']" type="button" class="btn text-white mx-2 mt-4 fw-bold">
          {{ 'ecash.success.page.close.button' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
